import React from "react";

export default function HeroTabpanels({ children }) {
  return <div className='hero-block__tabpanels'>{children}</div>;
}
